console.log("✅ variant-autofix.js LOADED");

(function () {
  const CONFIG = {
    chainMap: {
      bronze: "Brass Chain",
      brass: "Brass Chain",
      silver: "Stainless Steel Chain",
      "stainless steel": "Stainless Steel Chain",
      sterling: "Stainless Steel Chain",
    },
    defaultChain: "Stainless Steel Chain",
  };

  function getDesiredChain(material) {
    if (!material) return CONFIG.defaultChain;
    const normalized = material.toLowerCase();
    for (const [key, chain] of Object.entries(CONFIG.chainMap)) {
      if (normalized.includes(key)) {
        return chain;
      }
    }
    return CONFIG.defaultChain;
  }

  function syncChain() {
    const materialInput = document.querySelector('input[name*="Material"]');
    const chainInput = document.querySelector('input[name*="Chain"]');

    if (!materialInput || !chainInput) return;

    const material = materialInput.value;
    const currentChain = chainInput.value;
    const desiredChain = getDesiredChain(material);

    console.log("[variant-autofix]", { material, currentChain, desiredChain });

    if (currentChain === desiredChain) return;

    const option = document.querySelector(`.select-popout__option[data-value="${desiredChain}"]`);

    if (!option) return;

    // Skip if unavailable
    if (option.classList.contains("unavailable")) {
      console.log(`[variant-autofix] "${desiredChain}" still unavailable, retrying...`);
      setTimeout(syncChain, 200);
      return;
    }

    option.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true }));
    console.log(`[variant-autofix] Changed to: ${desiredChain}`);
  }

  document.addEventListener("click", (e) => {
    const option = e.target.closest(".select-popout__option");
    if (!option) return;

    const popout = option.closest("popout-select");
    const input = popout?.querySelector('input[name*="Material"]');

    if (input) {
      // Wait for theme to update availability, then sync
      setTimeout(syncChain, 500);
    }
  }, true);

  setTimeout(syncChain, 500);
})();